// One sidebar row. Either a NavLink (unlocked) or a visible-but-
// disabled placeholder (locked). Same shape so the locked variant
// reads as "this is a real product feature you don't have access to".

import { NavLink } from 'react-router-dom';
import { Lock } from 'lucide-react';

const baseCls = 'strata-sidebar-item flex items-center gap-2.5 py-2 rounded-md text-[12px] font-medium';
const baseStyle = { fontFamily: 'var(--strata-font-body)', letterSpacing: '0.02em' };

export function LockedNavItem({ item, collapsed }) {
  const { to, icon: Icon, label, testId } = item;
  return (
    <div
      key={to}
      data-testid={`${testId}-locked`}
      aria-disabled="true"
      title={collapsed ? `${label} — Locked. Contact admin.` : 'Locked — contact admin'}
      className={`${baseCls} opacity-30 cursor-not-allowed select-none ${collapsed ? 'justify-center px-0' : 'pl-[10px] pr-3'}`}
      style={baseStyle}
    >
      <Icon style={{ width: 16, height: 16, color: 'currentColor', flexShrink: 0 }} />
      {!collapsed && (
        <>
          <span className="flex-1 truncate line-through">{label}</span>
          <Lock className="w-3 h-3 flex-shrink-0" style={{ color: 'currentColor' }} />
        </>
      )}
    </div>
  );
}

export function UnlockedNavItem({ item, collapsed, onClick }) {
  const { to, icon: Icon, label, testId, badge, beta } = item;
  return (
    <NavLink
      key={to}
      to={to}
      end={to === '/'}
      data-testid={testId}
      onClick={onClick}
      title={collapsed ? label : undefined}
      className={({ isActive }) =>
        `${baseCls} ${collapsed ? 'justify-center px-0' : isActive ? 'pl-2 pr-3' : 'pl-[10px] pr-3'} ${isActive ? 'active' : ''}`
      }
      style={baseStyle}
    >
      {({ isActive }) => (
        <>
          <Icon style={{
            width: 16, height: 16, flexShrink: 0,
            color: isActive ? 'var(--strata-steel-2)' : 'currentColor',
          }} />
          {!collapsed && (
            <>
              <span className="flex-1 truncate">{label}</span>
              {beta && (
                <span data-testid={`${testId}-beta`} className="text-[9px] px-1.5 py-0.5 rounded-full font-bold uppercase tracking-wider" style={{ background: 'rgba(196,165,97,0.18)', color: '#D9BD7E' }}>
                  Beta
                </span>
              )}
              {badge && (
                <span className="text-[9px] px-1.5 py-0.5 rounded-full font-bold uppercase tracking-wider" style={{ background: 'rgba(180,83,83,0.18)', color: '#E07A7A' }}>
                  {badge}
                </span>
              )}
            </>
          )}
          {/* Collapsed: tiny dot indicator if there's a badge so the
              user knows there's something needing attention. */}
          {collapsed && (badge || beta) && (
            <span
              className="absolute right-1.5 top-1.5 w-1.5 h-1.5 rounded-full"
              style={{ background: badge ? '#E07A7A' : '#D9BD7E' }}
            />
          )}
        </>
      )}
    </NavLink>
  );
}
